import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiExternalLink, FiX } = FiIcons;

const Portfolio = ({ projects }) => {
  const [activeUrl, setActiveUrl] = useState(null);

  return (
    <>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {projects.map((project, index) => (
          <motion.div
            key={index}
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: index * 0.03, duration: 0.3 }}
            onClick={() => setActiveUrl(project.url)}
            className="group relative bg-white rounded-xl p-6 border border-slate-200 hover:border-blue-500 hover:shadow-lg transition-all duration-300 cursor-pointer"
          >
            <div className="flex justify-between items-start gap-4">
              <div className="flex-1">
                <h3 className="text-lg font-bold text-slate-900 group-hover:text-blue-600 transition-colors mb-2">
                  {project.title}
                </h3>
                <p className="text-slate-600 text-sm leading-relaxed line-clamp-3">
                  {project.description}
                </p>
              </div>
              <button
                className="flex-shrink-0 p-2.5 bg-slate-50 rounded-lg text-slate-600 shadow-sm group-hover:bg-blue-600 group-hover:text-white transition-all duration-300"
                aria-label={`View ${project.title}`}
              >
                <SafeIcon icon={FiExternalLink} className="text-lg" />
              </button>
            </div>
          </motion.div>
        ))}
      </div>

      <AnimatePresence>
        {activeUrl && (
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: 20 }}
            className="fixed inset-0 z-50 flex flex-col bg-slate-900"
          >
            <div className="flex items-center justify-between p-4 bg-slate-900 text-white shadow-md">
              <div className="text-sm font-medium truncate flex-1 pr-4 text-slate-300 hidden md:block">
                Previewing: {activeUrl}
              </div>
              <div className="text-sm font-medium truncate flex-1 pr-4 text-slate-300 md:hidden">
                Website Preview
              </div>
              <button
                onClick={() => setActiveUrl(null)}
                className="flex items-center gap-2 bg-slate-800 hover:bg-slate-700 hover:text-white px-5 py-2.5 rounded-lg transition-all font-bold"
              >
                <SafeIcon icon={FiX} className="text-xl" />
                <span>Close Preview</span>
              </button>
            </div>
            <div className="flex-1 w-full bg-slate-50 relative">
              <iframe
                src={activeUrl}
                className="absolute inset-0 w-full h-full border-0"
                title="Website Preview"
                sandbox="allow-same-origin allow-scripts allow-popups allow-forms"
              />
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
};

export default Portfolio;